import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import cn from "classnames";

import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";
import { Changer, ChangerPopup } from "../../../EditorBar";

import { IProps } from "./interfaces";
import messages from "./messages";
import { taskThemeColors } from "./utils";
import { ColorChangePopup } from "./styles";
import { convertToNewColors } from "../../../../../utils/convertToNewColors";

const ChangeColor = ({ openChanger, handleChangeOpen, color, plan, taskIndex, setPopupRef }: IProps) => {
    const dispatch = useDispatch();
    const handleChangeColor = (color: string) => {
        dispatch(editTask({ taskIndex, changingProp: "color", val: color }));
        dispatch(post("task-change-color", {
            planId: plan._id,
            index: taskIndex,
            color,
        }));
    };
    return (
        <Changer active={openChanger === "color"}>
            <div
                onClick={e => {
                    e.stopPropagation();
                    handleChangeOpen("color");
                }}
            >
                <div className={"ColorChanger"}>
                    <div className={cn("Label", "prop-label")}>
                        <FormattedMessage {...messages.color} />:
                    </div>
                    <div
                        className={"ColorRect ColorRectBase"}
                        style={{
                            backgroundColor: convertToNewColors(color || taskThemeColors[0]),
                        }}
                    ></div>
                </div>
            </div>
            {openChanger === "color" && (
                <ChangerPopup setRef={setPopupRef} onRight>
                    <ColorChangePopup>
                        {taskThemeColors.map(color => (
                            <div
                                key={color}
                                className={cn("ColorRect", "ColorRectPopup")}
                                style={{ backgroundColor: convertToNewColors(color) }}
                                onClick={() => handleChangeColor(color)}
                            />
                        ))}
                    </ColorChangePopup>
                </ChangerPopup>
            )}
        </Changer>
    );
};

export default ChangeColor;
